"use strict";
var StyleGuideColor = React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "style-guide-color" }, /* @__PURE__ */ React.createElement("div", { className: "style-guide-color__sample--" + this.props.name }, "$", this.props.name), /* @__PURE__ */ React.createElement("div", { className: "style-guide-color__description" }, this.props.description));
  }
});
export default StyleGuideColor;
